import { useState } from "react";

const YoutubeModal = ({ setOpenModal, url }) => {
  const [isOpen, setIsOpen] = useState(true);

  const handleClose = (e) => {
    if (e.target.id === "overlay") {
      setIsOpen(false);
      setOpenModal(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          id="overlay"
          className="fixed inset-0 flex items-center justify-center bg-opacity-50 z-[1000]"
          style={{ background: "rgba(0, 0, 0, 0.2)" }}
          onClick={handleClose}
        >
          <div className="w-[90vw] lg:w-[58vw] z-[1001] h-[55vh]">
            <iframe
              className="rounded-lg"
              width="100%"
              height="100%"
              src={url} // Use formatted embed URL
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default YoutubeModal;
